module.exports = __webpack_public_path__ + "assets/media/table-empty-state.9d578596.svg";